// RetrievalBaseline.js
import React, { useState } from 'react';
import {
  Button,
  Box,
  Typography,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  TextField,
  FormGroup,
  FormControlLabel,
  Checkbox,
} from '@mui/material';
import Autocomplete from '@mui/material/Autocomplete';

const evaluationCriteriaOptions = ['Generation','Retrieval'];

const RetrievalBaseline = ({ handleBatch, isSubmitting, modelOptions = [], baselineTenantList, defaultEmail, DBType }) => {
    const [selectedOption, setSelectedOption] = useState('');
    const [userEmail, setUserEmail] = useState(defaultEmail || '');
    const [evaluationCriteria, setEvaluationCriteria] = useState(['Retrieval']);
    const fakeOptions = ['Option 1', 'Option 2', 'Option 3'];
    const [modelList, setModelList] = useState('');
    const [selectedBaselineTenant, setSelectedBaselineTenant] = useState('');

  /* -------------------------------------------------------------- */
  /*  check-box toggle                                               */
  /* -------------------------------------------------------------- */
  const handleCriteriaToggle = (e) => {
    const { name, checked } = e.target;
    setEvaluationCriteria((prev) =>
      checked ? [...prev, name] : prev.filter((c) => c !== name)
    );
  };

  /* -------------------------------------------------------------- */
  /*  submit handler                                                 */
  /* -------------------------------------------------------------- */
  const handleSubmit = () => {
    if (!setModelList) {
      alert('Please select a baseline item.');
      return;
    }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(userEmail)) {
      alert('Please enter a valid email address.');
      return;
    }

    const payload = {
      selectedBaseline: selectedOption,
      userEmail,
      evaluationCriteria,
      selectedModel: modelList,
      selectedBaselineTenant,
      DBType: DBType,
    };

    handleBatch(payload);
  };

  /* -------------------------------------------------------------- */
  /*  UI                                                             */
  /* -------------------------------------------------------------- */
  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        Select a Retrieval Baseline
      </Typography>
    {/* Baseline Tenant Dataset */}
    <Autocomplete
    options={baselineTenantList}œ
    value={selectedBaselineTenant || null}
    onChange={(_, v) => setSelectedBaselineTenant(v ? [v] : [])}  // wrap single value into an array
    renderInput={(params) => (
        <TextField {...params} label="Select baseline tenant dataset" />
    )}
    sx={{ mb: 2 }}
    />

    {/* Model */}
    <Autocomplete
        options={modelOptions}
        value={modelList}
        onChange={(_, v) => setModelList(v || '')}
        renderInput={(params) => (
            <TextField {...params} label="Select model" />
        )}
        sx={{ mb: 2 }}
    />


      {/* Evaluation Criteria -------------------------------------------- */}
      <Typography variant="subtitle1" sx={{ mt: 2 }}>
        Evaluation Criteria
      </Typography>
      <FormGroup sx={{ mb: 3 }}>
  {evaluationCriteriaOptions.map((opt) => (
    <FormControlLabel
      key={opt}
      control={
        <Checkbox
          checked={evaluationCriteria.includes(opt)}
          onChange={handleCriteriaToggle}
          name={opt}
          disabled={opt === 'Retrieval'} // 🚀 disable this checkbox
        />
      }
      label={opt}
    />
  ))}
</FormGroup>

      {/* Notification Email -------------------------------------------- */}
      <TextField
        label="Send notification to:"
        type="email"
        fullWidth
        value={userEmail}
        onChange={(e) => setUserEmail(e.target.value.trim())}
        sx={{ mb: 3 }}
      />

      {/* Submit Button ------------------------------------------------- */}
      <Button
        variant="contained"
        color="primary"
        onClick={handleSubmit}
        disabled={isSubmitting}
        fullWidth
      >
        Submit Retrieval Baseline
      </Button>
    </Box>
  );
};

export default RetrievalBaseline;
